module.exports = __webpack_public_path__ + "static/media/speakers_logos_HKSTP.901ebe5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_HKSTP.jpg
// module id = 270
// module chunks = 0